import { Modal, Table } from "antd";

const CommentsModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  lectureFeedbackComments = []
}) => {
  const columns = [
    {
      title: "S no.",
      dataIndex: "index",
      key: "index",
      width: 100
    },
    {
      title: "User Email",
      dataIndex: "userEmail",
      key: "userEmail"
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment"
    }
  ];
  return (
    <Modal
      title="Lecture Comments"
      centered
      width={1300}
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <Table
        columns={columns}
        dataSource={lectureFeedbackComments}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};

export default CommentsModal;
